import React from 'react';
import Grid from '@mui/material/Grid2';

import { 
  StartEquipmentOption,
  EquipmentPack,
} from "@dndModels";

import CheckBox from "@components/input/CheckBox";
import { renderOptionItem } from "@dndComponents/character/inventory/startingEquipment/CSE.types";
import TypeItemSelector from "@dndComponents/character/inventory/startingEquipment/CSETypeItemSelector";

// Individual Equipment Option Component
interface Props {
  option: StartEquipmentOption;
  isSelected: boolean;
  typeItemSelections: Record<string, string>;
  onSelect: () => void;
  onTypeItemSelect: (itemId: string, selectedItemId: string) => void;
  equipmentPacks: EquipmentPack[];
}

export default function EquipmentOption({
  option,
  isSelected,
  typeItemSelections,
  onSelect,
  onTypeItemSelect,
  equipmentPacks
}: Props) {
  const renderOptionLabel = () => {
    return option.items.map((item, i) => {
      const prefix = i > 0 ? ", " : "";
      return prefix + renderOptionItem(item, equipmentPacks);
    }).join("");
  };

  return (
    <Grid container spacing={0} direction="column">
      <Grid>
        <CheckBox 
          name={renderOptionLabel()} 
          value={isSelected} 
          onChange={onSelect} 
        />
      </Grid>
      {isSelected && (
        <>
          {option.items
            .filter(item => item.item_type === "Type")
            .map(item => (
              <TypeItemSelector
                key={item.id}
                item={item}
                selectedItemId={typeItemSelections[item.id] || ""}
                onSelect={(selectedItemId) => onTypeItemSelect(item.id, selectedItemId)}
              />
            ))}
        </>
      )}
    </Grid>
  );
}
